import React,{useState,useEffect,useRef} from "react";
import './classes/ConferenceRegistrationReports.css';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataGrid } from '@mui/x-data-grid';
 import { Link } from '@mui/material';
 import { format } from "date-fns";

const ConferenceRegistrationReport = ()=>{
    //  const initialForm = {    
    //     sel_confs:[],       
    //     start_date:'',
    //     start_date_obj:null,
    //     end_date:'',
    //     end_date_obj: null,
      
    //   };  

  const initialForm = () => {
    const params = new URLSearchParams(window.location.search);

    const defaultForm = {
      sel_confs:[],
      start_date:'',
      end_date:'',
      start_date_obj:null,
      end_date_obj:null,
      action: '',
    };

    //  normal dates
    const queryStart = params.get("start_date");
    const queryEnd = params.get("end_date");

    const startObj =
      queryStart
        ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
        : null;

    const endObj =
      queryEnd
        ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
        : null;

    // const sel_confs = (() => {
    //   if (!params.has("sel_confs")) return [];

    //   const allConferences = params.getAll("sel_confs");

    //   if (allConferences.length > 1) {
    //       return allConferences.filter(Boolean); 
    //   }

    //   if (allConferences.length === 1) {
    //       if (!allConferences[0]) return []; 

    //       return allConferences[0]
    //       .split(",")
    //       .filter(Boolean); 
    //   }

    //   return [];
    // })();

    const sel_confs = (() => {
    const values = [];

    for (const [key, value] of params.entries()) {
        if (key.startsWith("sel_confs[")) {
        if (value) values.push(value);
        }
    }

    return values;
    })();

    return {
      ...defaultForm,
      sel_confs: sel_confs,

      //  normal dates
      start_date: startObj ? queryStart : '',
      start_date_obj: startObj,

      end_date: endObj ? queryEnd : '',
      end_date_obj: endObj,

      action: '',
    };
  };   
      
    // const [appliedFormData, setAppliedFormData] = useState({
    //         sel_confs:[],       
    //         start_date:'',
    //         end_date:'',
    //     });
      const [appliedFormData, setAppliedFormData] = useState(initialForm());
      const startDateRef = useRef(null);
      const endDateRef = useRef(null);
      const [formData, setFormData] = useState(initialForm());
      const [submittedData, setSubmittedData] = useState(null);
      const [isLoading, setIsLoading] = useState(true);    
      const [formErrors, setFormErrors] =useState({});
      const[ConferenceList, setConferenceList] = useState({});
      const[productattendees, setProductAttendees] = useState([]);
      const[totalattendees, setTotalAttendees] = useState(0);
      const[totalamount, setTotalAmount] = useState(0);
      const [isSubmitted, setIsSubmitted] = useState(false);  
      const [isReportViewLoading, setIsReportViewLoading] = useState(true);

        const products = [
    { name: "2024 Winter Baseball Meetings Career Conference - General", attendees: 41 },
    { name: "2024 Winter Baseball Meetings Career Conference - Students", attendees: 66 },
    { name: "2024 Winter Baseball Meetings Career Conference - Teams", attendees: 4 },
    { name: "2025 Basketball Career Conference in Las Vegas - General", attendees: 31 },
    { name: "2025 Basketball Career Conference in Las Vegas - Students", attendees: 31 },
    { name: "2025 Basketball Career Conference in Las Vegas - Teams", attendees: 5 },
   
  ];

         const app_url = configData.APP_URL;
        useEffect(() => {
           Promise.all([
         retrieveConferences()
          ]).then(() => {
     
            setIsLoading(false);
          })
        }, []); 

   const handleConferencesChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, sel_confs: selectedValues }));
    };
     async function  retrieveConferences() {    
         try {
             setIsLoading(true);
            const response = await fetch(
                 app_url+'conferenceregistrationreport/getconferencelist',
                 {
                     method: "GET",
    
                     headers: {
                         'Content-Type': 'application/json',
                    },
                 }
             )
             const responsedata = await response.json();
             if(responsedata.data.msg === "Success") {
                 setConferenceList(responsedata.data.result);
            }
         }  catch (error) {
             console.error('Error fetching data:', error);
         } finally {
                 setIsLoading(false); 
         }
     }
  
    const columns = [
     {
    field: 'username',
    headerName: 'Username',
    flex:1,
    sortable: false,
    // minWidth:220,
    cellClassName:'username_column',headerClassName:'username_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.username}
      </Link>
  ),
    
  },
  {
    field: 'product_name',
    headerName: 'Conference',      
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'conference_column',headerClassName:'conference_header',
  },
  {
    field: 'country',
    headerName: 'Country',    
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'country_column',headerClassName:'country_header',
  },
   {
    field: 'registration_date',
    headerName: 'Registration Date', 
    sortable: false,  
    flex:1,
    // minWidth:230,
    cellClassName:'registration_date_column',headerClassName:'registration_date_header',
  },
  {
    field: 'first_name_badge',
    headerName: 'First Name Badge', 
    sortable: false,  
    flex:1,
    // minWidth:230,
    cellClassName:'first_name_badge_column',headerClassName:'first_name_badge_header',
  },
  {
    field: 'last_name_badge',
    headerName: 'Last Name Badge',   
    flex:1,
    sortable: false,
    //  minWidth:150,
    cellClassName:'last_name_badge_column',headerClassName:'last_name_badge_header',
  },
  {
    field: 'school_name',
    headerName: 'School or University Badge',   
    flex:1,
    sortable: false,
    //  minWidth:150,
    cellClassName:'school_or_university_badge_column',headerClassName:'school_or_university_badge_header',
  }, 

];
  const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

// const handleDateChange = (date) => {
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//            setFormData(prev => ({ ...prev, start_date: formattedDate }));
//          };
//       const handleEndDateChange = (date) => {
       
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//             setFormData(prev => ({ ...prev, end_date: formattedDate }));
//       };
  const handleDateChange = (date, field) => {
    setFormData(prev => ({
      ...prev,
      [`${field}_obj`]: date,                   
      [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
  };

  const validateDates = (formData) => {
    let errors = {};

      if (formData.start_date && !formData.end_date) {
    errors.end_date = "End date is required if start date is filled.";
  }

  if (formData.end_date && !formData.start_date) {
    errors.start_date = "Start date is required if end date is filled.";
  }
    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }
     return errors;
  };
   
  React.useEffect(() => {
                  if (isReportViewLoading) return;
                   const fetchData = async () => {
                   // Simulate API call to your server
                    // In a real application, replace this with your actual fetch logic
              try {
               setIsLoading(true);
             const response = await fetch(app_url+'conferenceregistrationreport/getlist', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({
                 page: paginationModel.page,
                 pageSize: paginationModel.pageSize,
                 sortModel,
                 filterModel,
                // formData:formData
                // formData:appliedFormData,
                  formData: {
                    ...appliedFormData,
                    action: isSubmitted ? 'submit' : ''
                  }
               }),
             });
             const data = await response.json();
             
              setRows(data.data.rows);
              setRowCount(data.data.totalRowCount); // Server should return totalRowCount
              setProductAttendees(data.data.product_count_details);
              setTotalAttendees(data.data.total_attendees);
              setTotalAmount(data.data.total_amount);
             
              }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
                if (isSubmitted) {
                  setIsSubmitted(false);
                }
              }
                 
           };
           
       
           fetchData();
        
             }, [paginationModel, sortModel, filterModel, appliedFormData, isReportViewLoading]); // Re-fetch data when these change 

const submitFormData = async (data) => {
  setSubmittedData(data);
  setAppliedFormData(data);
  setIsSubmitted(false);
};

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload

    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
  
    setPaginationModel({
      page: 0,
      pageSize: 50,
    });
    setSubmittedData(formData);
    setAppliedFormData({ ...formData });
    setIsSubmitted(true);
      // try {
      //   setIsLoading(true);
      //  const response = await fetch(app_url+'conferenceregistrationreport/getlist', {
      //   method: 'POST',
      //  headers: { 'Content-Type': 'application/json' },
      //  body: JSON.stringify({
      //     page: 0,
      //     pageSize: 50, 
      //     sortModel,
      //     filterModel,
      //     formData:formData
      //    }),
      //  });
      //  const data = await response.json();
      //  console.log(data.data.rows);
      //  setRows(data.data.rows);
      //  setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      //  setProductAttendees(data.data.product_count_details);
      //  setTotalAttendees(data.data.total_attendees);
      //  setTotalAmount(data.data.total_amount);
      //  }  catch (error) {
      //        console.error('Error fetching data:', error);
      //      } finally {
      //        setIsLoading(false); // Set loading to false after fetch completes (success or error)
      //      }
  };
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload

    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
   
     try {
         setIsLoading(true);
       const response = await fetch(app_url+'conferenceregistrationreport/getexport', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({
          
           formData:formData
        }),
       });
       const data = await response.json();
      const csvUrl = data.data.csvUrl;
       const urlParts = csvUrl.split('/');
         const fileName = urlParts[urlParts.length - 1];
                 const link = document.createElement('a');
                 link.href = csvUrl;
                 link.setAttribute('download', fileName);
                 document.body.appendChild(link);
                 link.click();
                 link.parentNode.removeChild(link);
      
       }  catch (error) {
             console.error('Error fetching data:', error);
           } finally {
             setIsLoading(false); // Set loading to false after fetch completes (success or error)
           }


  };

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);

  //   if ([...params.keys()].length > 0) {
  //     const init = initialForm();

  //     setFormData(init);
  //     submitFormData(init);
  //   }
  // }, []);

  const normalizeBackendData = (backendParams) => {
    return {
      ...backendParams,

      start_date_obj: backendParams.start_date
        ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
        : null,

      end_date_obj: backendParams.end_date
        ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
        : null,
    };
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reportViewId = params.get("report_view_id");

    const baseForm = initialForm(); 

    if (reportViewId) {
      const fetchData = async () => {
        try {
          const res = await fetch(app_url + 'report/getreportfilters', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: reportViewId }),
          });

          const data = await res.json();
          const backendParams = data?.data?.params || {};

          //  normalize backend
          const normalized = normalizeBackendData(backendParams);

          //  merge (backend overrides URL/defaults)
          const finalData = {
            ...baseForm,
            ...normalized,
          };

          setFormData(finalData);
          submitFormData(finalData);

        } catch (err) {
          console.error(err);
        } finally {
          setIsReportViewLoading(false); 
        }
      };

      fetchData();
    } else {
      //  fallback → only URL/default
      // if ([...params.keys()].length > 0) {
        setFormData(baseForm);
        submitFormData(baseForm);
        // setAppliedFormData(null);  
        setSubmittedData(null); 
      // }
        setIsReportViewLoading(false);
    }

  }, []);

    return(
           <>
            {isLoading ? (
              <Loading />
            ) : (
        <div id="main" className="conference-registration-report-main">
                <Helmet>
                    <title>
                        smww conference registration
                    </title>
                </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                <div className="conference-registration-report-container">
                <h1>Conference Registration Report</h1>
                 <form onSubmit={handleSubmit}>
      
                                        <div>
                                            <label>Select conferences:</label>
                                            <select 
                                        name="sel_confs" 
                                        multiple={true}
                                        size="15" 
                                        style={{width:"40%"}}
                                        className="" 
                                        onChange={handleConferencesChange}
                                        value={formData.sel_confs || []}
                                    >
                                        {ConferenceList.length > 0 && (
                                            <>
                                                {ConferenceList.map((item) => {
                                                    return <>
                                                        {item['id'] != null && (
                                                            <><option value={item['id']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                    </select>
                                        </div>
                <div className='form-item'>
                    <label htmlFor="start_date">Start Date:</label>
                    <DatePicker
                    ref={startDateRef}
                    // selected={formData.start_date}
                    selected={formData.start_date_obj}
                    //onChange={(date) => setFormData({ ...formData, start_date: date })}
                    id="start_date"
                    name="start_date" 
                    // onChange={handleDateChange}
                    onChange={(date) => {
                      handleDateChange(date, "start_date");
                      setTimeout(() => {
                          const input = startDateRef.current?.input;
                          if (input) {
                          const len = input.value.length;
                          input.setSelectionRange(len, len);
                          }
                      }, 0);
                    }}
                    className=""
                    // required
                    />   
                  {formErrors.start_date && (
                    <div className="error">{formErrors.start_date}</div>
                  )}                 
                </div>
                <div className='form-item'>
                    <label htmlFor="end_date">End Date:</label>
                    <DatePicker
                    // selected={formData.end_date}
                    ref={endDateRef}
                    selected={formData.end_date_obj}
                    // onChange={handleEndDateChange}
                    onChange={(date) => {
                      handleDateChange(date, "end_date");
                      setTimeout(() => {
                          const input = endDateRef.current?.input;
                          if (input) {
                          const len = input.value.length;
                          input.setSelectionRange(len, len);
                          }
                      }, 0);
                    }}
                    id="end_date"
                    name="end_date"
                    className=""
                    // required
                    />  
                  {formErrors.end_date && (
                    <div className="error">{formErrors.end_date}</div>
                  )}                 
                </div>
                
                <div className="">
                          <input type="submit" value="Submit" className="form-submit"  />&nbsp; &nbsp;
                          <a href="/conference-registration"><input type="button" name="" value="Reset" class="form-submit" /></a>&nbsp; &nbsp;
                           <input type="button" value="Export" className="form-submit"  onClick={handleExport}/>
                           
                      </div>
                 </form>
                    {submittedData && (
                  <>
                  <div id="" className="total" style={{marginRight:"10px"}}><b>Total Sales: {totalamount}</b></div>
                  <div id="" className="total"><b>Total Attendees: {totalattendees}</b></div>
                  <div style={{clear:"both"}}></div>
                    <div id="total_product" className="page-view-myorders">
      <div className="panel panel-default">
        <div className="panel-heading" style={{ background: "#fefefe" }}>
          <b>Breakdown per conference</b>
        </div>
        <div className="panel-body">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Product</th>
                <th>Event Attendees</th>
              </tr>
            </thead>
            <tbody>
              {productattendees.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.attendees}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
                                        </>
                 )} 
              
                 
                 <div className="conference-registration-report-table">
                                           <table className="">
                                                <div style={{ width: '100%' }}>
                                                <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                //disableColumnResize={true}
                                            />
                                               </div>
                                            </table>
                                            </div>
                 
</div>
            </div>
            <div className="right">
                 
            </div>
        </div>
               )}
    </>
       
    );
};
export default ConferenceRegistrationReport;